import React, {Component} from 'react';
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import { closeActivationModal } from '../actions/activation.js'
import { checkAccountStatus } from '../actions/auth.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class Activation extends Component {

	static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

	closeActivationModal() {
		const { dispatch } = this.props
		dispatch(closeActivationModal())

		let account = this.props.account
		if (account) {
			dispatch(checkAccountStatus(account._id))
		}
	}

	render() {
		return (
			<div style={{ height: 120, width: 200}}>
				<Modal
					keyboard={false}
					backdrop="static"
					show={this.props.showActivationModal}
					onHide={this.closeActivationModal.bind(this)}>
					<Modal.Header>
          </Modal.Header>
			    <Modal.Body>
						<div class="text-center">
						<br/>
						<p>Your account needs to be activated.</p>
						<p>Please verify your email!</p>
						<br/><br/><br/><br/>
					</div>
					</Modal.Body>
			    <Modal.Footer>
						<Button bsStyle="primary" block onClick={this.closeActivationModal.bind(this)}>Ok</Button>
					</Modal.Footer>
			  </Modal>
			</div>
		)
	}
}
const mapStateToProps = state => {
  return {...state.activationReducer, account: state.authReducer.account}
}

export default withRouter(
  connect(mapStateToProps)(Activation)
);



// WEBPACK FOOTER //
// ./src/components/Activation.js